import React from "react";
import { PaymentType } from "univapay-node";

import { Content } from "../common/FormConfirm";

export const ContentOnline = () => <Content paymentType={PaymentType.ONLINE} />;

export default ContentOnline;
